module.exports = __webpack_public_path__ + "img/mouth4.49e4142d.svg";